import { render, staticRenderFns } from "./ConfigurationReact.vue?vue&type=template&id=cbdbbde8&"
import script from "./ConfigurationReact.vue?vue&type=script&lang=js&"
export * from "./ConfigurationReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports